export default "__VITE_ASSET__mpwpQ6VS__"